// extracted by mini-css-extract-plugin
export default {"Panneau":"PageAbonnement_Panneau__SG3Gd","EntetePanneau":"PageAbonnement_EntetePanneau__opdtZ","Total":"PageAbonnement_Total__9pNkj"};